import React from 'react'

export const Loader: React.FC<{ size?: string }> = ({ size = 'h-10 w-10' }) => (
  <div className={`animate-spin rounded-full border-4 border-primary-500 border-t-transparent ${size}`} />
)

export const StatCard: React.FC<{ title: string; value: string; icon: string; color?: string }> = ({ title, value, icon, color = 'bg-primary-50 text-primary-700' }) => (
  <div className="card p-5 flex items-center gap-4">
    <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl ${color}`}>{icon}</div>
    <div>
      <div className="text-xs text-gray-500">{title}</div>
      <div className="text-xl font-black text-gray-900 mt-0.5">{value}</div>
    </div>
  </div>
)

export const Spinner: React.FC = () => <Loader size="h-6 w-6" />

export interface ModalProps {
  open: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
  wide?: boolean
}

export const Modal: React.FC<ModalProps> = ({ open, title, onClose, children, wide }) => {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40" onClick={onClose}>
      <div
        className={`bg-white rounded-2xl shadow-xl w-full ${wide ? 'max-w-3xl' : 'max-w-lg'} max-h-[90vh] overflow-y-auto`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 sticky top-0 bg-white rounded-t-2xl">
          <h3 className="font-black text-gray-900">{title}</h3>
          <button className="text-gray-400 hover:text-gray-700 text-xl leading-none" onClick={onClose}>×</button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  )
}